import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  MsalBroadcastService,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import { Location } from '@angular/common';
import { JwtValidatorService } from '../services/jwt-validator.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class OauthInterceptor implements HttpInterceptor {
  private msalInterceptor: MsalInterceptor;

  constructor(
    private msalService: MsalService,
    @Inject(MSAL_INTERCEPTOR_CONFIG) private msalInterceptorConfig: MsalInterceptorConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private location: Location,
    @Inject(DOCUMENT) private document: Document,
    private jwtValidator: JwtValidatorService,
    private authService: AuthService
  ) {
    this.msalInterceptor = new MsalInterceptor(
      this.msalInterceptorConfig,
      this.msalService,
      this.location,
      this.msalBroadcastService,
      this.document
    );
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authProvider = sessionStorage.getItem('auth_provider');
    console.log('[OauthInterceptor] Auth provider:', authProvider, '| URL:', req.url);

    if (authProvider === 'msal') {
      return this.msalInterceptor.intercept(req, next);
    } else if (authProvider === 'salesforce') {
      const salesforceToken = sessionStorage.getItem('sales_force_token');

      if (salesforceToken) {
        // Validar expiración ANTES de enviar la petición
        if (this.jwtValidator.isTokenExpired(salesforceToken)) {
          this.authService.clearSalesforceSessionAndRedirect();
          return throwError(() => new HttpErrorResponse({
            status: 401,
            statusText: 'Token expired'
          }));
        }

        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${salesforceToken}`,
            'X-Auth-Provider': 'salesforce'
          }
        });

        return next.handle(clonedReq).pipe(
          catchError((error: HttpErrorResponse) => {
            console.log('[OauthInterceptor] Caught error:', error.status, '| Message:', error.message);
            // Manejar errores 401/403 del backend (token expirado en tránsito)
            if (error.status === 401 || error.status === 403) {
              console.log('[OauthInterceptor] Redirecting to login...');
              this.authService.clearSalesforceSessionAndRedirect();
            }
            return throwError(() => error);
          })
        );
      }
    }
    return next.handle(req);
  }
}

export const OauthInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: OauthInterceptor,
  multi: true
};
